import type { NationalIdRules } from '../types';

const stripPunctuation = (value: string): string =>
  value.replace(/[.\s-_/]/g, '').trim();

/**
 * Neutral rules when address country is missing or unsupported.
 * Accepts a bounded generic identifier; no country-specific checksum.
 */
export const fallbackNationalId: NationalIdRules = {
  countryCode: 'XX',
  documentKind: 'GENERIC',
  labelKey: 'country.default.idCard',
  invalidKey: 'country.identifier.invalid',
  placeholder: '',
  normalize: (value: string) => stripPunctuation(value),
  format: (value: string) => (value || '').trim(),
  validate: (value: string) => {
    const cleaned = stripPunctuation(value || '');
    return cleaned.length >= 5 && cleaned.length <= 20;
  },
  searchToken: (value: string) => stripPunctuation(value).toLowerCase(),
};
